<template>
    <div class="desktop-main">
        <div class="admin-body">
            <el-form ref="form" :model="tableParams" label-width="80px" :inline="true">
                <el-form-item label="状态">
                    <el-select v-model="tableParams.status" placeholder="请选择状态" clearable>
                        <el-option :key="0" label="禁用" :value="0"></el-option>
                        <el-option :key="1" label="启用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryTaskClick">查询</el-button>
                    <el-button type="primary" @click="insertTaskClick">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData.list"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="ID"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="typeName"
                    label="类型"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="code"
                    label="编码"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="售价"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="customTextStatus"
                    label="自定义文字"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.customTextStatus == 0" style="color: orange; font-weight: 400;">无</span>
                        <span v-if="scope.row.customTextStatus == 1" style="color: blue; font-weight: 400;">有</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" style="color: red; font-weight: 600;">禁用</span>
                        <span v-if="scope.row.status == 1" style="color: green; font-weight: 600;">启用</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editTaskInfoClick(scope.row)" type="primary" size="small">编辑</el-button>
                        <el-button @click="toggleStatusClick(scope.row)" type="warning" size="small">切换状态</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="form-pagination">
                <el-pagination
                    :current-page="tableData.pageNum"
                    :page-size="tableData.pageSize"
                    layout="total, prev, pager, next"
                    :total="tableData.total"
                    @prev-click="changePage(-1)"
                    @next-click="changePage(1)"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>

        <el-dialog :title="dialogTaskInfo.newUpdateTitle" :visible.sync="dialogTaskInfo.newUpdateVisible" width="40%">
            <div class="dialog-person-body">
                    <el-form ref="form" :model="dialogTaskInfo.taskInfo" label-width="80px">
                        <el-form-item label="名称">
                            <el-input v-model="dialogTaskInfo.taskInfo.name"></el-input>
                        </el-form-item>
                        <el-form-item label="售价(元)">
                            <el-input v-model="dialogTaskInfo.taskInfo.price"></el-input>
                        </el-form-item>
                        <el-form-item label="左图片">
                            <el-image
                                v-if="dialogTaskInfo.taskInfo.leftTextUrl"
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.leftTextUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.leftTextUrl]">
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :on-remove="handleRemoveByLeftPic"
                                :limit="1"
                                :on-exceed="handleExceedByLeftPic"
                                :on-success="handleSuccessByLeftPic"
                                :file-list="leftFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽1195，高1760</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="右图片">
                            <el-image
                                v-if="dialogTaskInfo.taskInfo.rightTextUrl"
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.rightTextUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.rightTextUrl]">
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :on-remove="handleRemoveByRightPic"
                                :limit="1"
                                :on-exceed="handleExceedByRightPic"
                                :on-success="handleSuccessByRightPic"
                                :file-list="rightFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽1195，高1760</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="背景图">
                            <el-image
                                v-if="dialogTaskInfo.taskInfo.bgPicUrl"
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.bgPicUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.bgPicUrl]">
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :on-remove="handleRemoveByRightPic"
                                :limit="1"
                                :on-exceed="handleExceedByRightPic"
                                :on-success="handleSuccessByRightPic"
                                :file-list="bgFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽5160，高1760</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="LOGO">
                            <el-image
                                v-if="dialogTaskInfo.taskInfo.logoUrl"
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.logoUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.logoUrl]">
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :on-remove="handleRemoveByLogoPic"
                                :limit="1"
                                :on-exceed="handleExceedByLogoPic"
                                :on-success="handleSuccessByLogoPic"
                                :file-list="logoFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽高为1：1，建议300*300</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="Banner图">
                            <el-image
                                v-if="dialogTaskInfo.taskInfo.bannerUrl"
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.bannerUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.bannerUrl]">
                            </el-image>
                            <el-upload
                                class="upload-demo"
                                :action="uploadUrl"
                                :headers="uploadHeaders"
                                :on-remove="handleRemoveByBannerPic"
                                :limit="1"
                                :on-exceed="handleExceedByBannerPic"
                                :on-success="handleSuccessByBannerPic"
                                :file-list="bannerFileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽5160，高1200</div>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="排序">
                            <el-input v-model="dialogTaskInfo.taskInfo.sort"></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="dialogTaskInfo.taskInfo.status" placeholder="请选择状态" clearable>
                                <el-option :key="0" label="禁用" :value="0"></el-option>
                                <el-option :key="1" label="启用" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="newUpdateTaskClick">保存</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </el-dialog>
    </div>
</template>

<script>
import NProgress from 'nprogress'
import { queryHandTextByPageApi, addOrUpdateHandTextApi, updateHandTextStatusApi } from '@/api/api';

    export default {
        components: { 
        },
        data() {
            return {
                tableParams: {
                    status: '',
                    queryStartTimes: [],
                    orderBy: '',
                },
                tableData: {
                    list: [],
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                dialogTaskInfo: {
                    newUpdateTitle: '新增',
                    newUpdateVisible: false,
                    taskInfo: {
                        id: '',
                        name: '',
                        price: '0',
                        leftTextUrl: '',
                        rightTextUrl: '',
                        logoUrl: '',
                        sort: 0,
                        status: 1,
                    }
                },
                adminType: 2,
                // 图片上传
                uploadUrl: process.env.ENV_HOST + "/admin/commonFile/uploadPic",
                uploadHeaders: {},
                leftFileList: [],
                rightFileList: [],
                bgFileList: [],
                logoFileList: [],
                bannerFileList: [],
            }
        },
        filters: {
        },
        methods: {
            init(){
                const orgPath = this.$route.path
                // this.$router.push({ path: '/task_mgr/task_sub_mgr', query:{taskId:1, orgPath: orgPath} });
                let user = sessionStorage.getItem('user');
                this.adminType = JSON.parse(user).adminType
                this.uploadHeaders = {
                    token: sessionStorage.getItem('token'),
                    identity: 2
                }
                this.queryTaskClick()                
            },
            queryTaskClick(){
                // 查询
                NProgress.start();
                let params = {
                    ...this.buildQueryParams(this.tableParams), 
                    pageNum: this.tableData.pageNum, 
                    pageSize: this.tableData.pageSize, 
                }
                queryHandTextByPageApi(params).then(data => {
                    this.tableData = data.result
                    this.tableData.total = Number.parseInt(this.tableData.total)
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            resetParamsClick(){
                this.tableParams.status = ''
                this.tableParams.queryStartTimes = []
                this.tableParams.orderBy = ''
            },
            buildQueryParams(tableParams){
                let newParams = {
                    ...this.tableParams
                }
                if (tableParams.queryStartTimes && tableParams.queryStartTimes[0]) {
                    newParams.queryStartTime = tableParams.queryStartTimes[0]
                }
                if (tableParams.queryStartTimes && tableParams.queryStartTimes[1]) {
                    newParams.queryEndTime = tableParams.queryStartTimes[1]
                }
                return newParams
            },
            insertTaskClick(){
                this.dialogTaskInfo.newUpdateTitle = '新增文字'
                this.dialogTaskInfo.newUpdateVisible = true
                this.dialogTaskInfo.taskInfo = {
                        id: '',
                        name: '',
                        price: '0',
                        leftTextUrl: '',
                        rightTextUrl: '',
                        sort: 0,
                        status: 1,
                    }
                this.leftFileList = []
                this.rightFileList = []
                this.bgFileList = []
                this.logoFileList = []
                this.bannerFileList = []
            },
            newUpdateTaskClick(){
                NProgress.start();
                let params = {
                    ...this.dialogTaskInfo.taskInfo
                }
                addOrUpdateHandTextApi(params).then(data => {
                    this.$message.success("操作成功")
                    this.dialogTaskInfo.newUpdateVisible = false
                    this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            editTaskInfoClick(data){
                console.log("编辑任务", data);
                this.dialogTaskInfo.newUpdateTitle = '编辑文字'
                this.dialogTaskInfo.newUpdateVisible = true
                this.dialogTaskInfo.taskInfo = data

                this.leftFileList = []
                this.rightFileList = []
                this.bgFileList = []
                this.logoFileList = []
                this.bannerFileList = []

                if (data.leftTextUrl) {
                    this.leftFileList = [
                        {
                            name: "左侧图片",
                            url: data.leftTextUrl
                        }
                    ]
                }
                if (data.rightTextUrl) {
                    this.rightFileList = [
                        {
                            name: "右侧图片",
                            url: data.rightTextUrl
                        }
                    ]
                }
                if (data.bgPicUrl) {
                    this.bgFileList = [
                        {
                            name: "背景图片",
                            url: data.bgPicUrl
                        }
                    ]
                }
                if (data.logoUrl) {
                    this.logoFileList = [
                        {
                            name: "logo图片",
                            url: data.logoUrl
                        }
                    ]
                }
                if (data.bannerUrl) {
                    this.bannerFileList = [
                        {
                            name: "Banner图",
                            url: data.bannerUrl
                        }
                    ]
                }
            },
            // deleteTaskClick(row){
            //     // 删除
            //     NProgress.start();
            //     let params = {
            //         ...row
            //     }
            //     deleteTaskByIdApi(params).then(data => {
            //         this.$message.success("删除成功")
                    
            //         this.resetParamsClick()
            //         this.queryTaskClick()
            //         NProgress.done();
            //     }).catch(error => {
            //         this.$message.error(error.message);
            //         NProgress.done();
            //     });
            // },
            changePage(index){
                console.log("翻页", index);
                this.tableData.pageNum += index
                this.queryTaskClick()
            },
            handleCurrentChange(data){
                this.tableData.pageNum = data
                this.queryTaskClick()
            },
            newUpdateTaskClick(){
                if (this.dialogTaskInfo.taskInfo.id) {
                    // 更新
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    addOrUpdateHandTextApi(params).then(data => {
                        this.$message.success("更新成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        this.resetParamsClick()
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                } else {
                    // 新增
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    addOrUpdateHandTextApi(params).then(data => {
                        this.$message.success("新增成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        this.resetParamsClick()
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                }
            },
            toggleStatusClick(row){
                // 切换状态
                NProgress.start();
                let params = {
                    id: row.id,
                    status: row.status == 0 ? 1 : 0
                }
                updateHandTextStatusApi(params).then(data => {
                    this.$message.success("更新成功")
                    this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            handleRemoveByLeftPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.leftTextUrl = ''
            },
            handleExceedByLeftPic(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccessByLeftPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.leftTextUrl = result.url
            },
            handleRemoveByRightPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.rightTextUrl = ''
            },
            handleExceedByRightPic(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccessByRightPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.rightTextUrl = result.url
            },
            handleRemoveByBgPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.bgPicUrl = ''
            },
            handleExceedByBgPic(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccessByBgPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.bgPicUrl = result.url
            },
            handleRemoveByLogoPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.logoUrl = ''
            },
            handleExceedByLogoPic(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccessByLogoPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.logoUrl = result.url
            },
            handleRemoveByBannerPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.bannerUrl = ''
            },
            handleExceedByBannerPic(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleSuccessByBannerPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.bannerUrl = result.url
            },
        },
        mounted() {
            this.init()
        }
    }

</script>

<style lang="scss" scoped>
.desktop-main {
    width: calc(100% - 40px);
    padding: 20px;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}
</style>


// WEBPACK FOOTER //
// text_mgr.vue?40c7d4e1